import { render, staticRenderFns } from "./time_series_comparison.vue?vue&type=template&id=163f4c48&scoped=true"
import script from "./time_series_comparison.vue?vue&type=script&lang=js"
export * from "./time_series_comparison.vue?vue&type=script&lang=js"
import style0 from "./time_series_comparison.vue?vue&type=style&index=0&id=163f4c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f4c48",
  null
  
)

export default component.exports